import { GameController } from '@/components/game/GameController';
import { FogBackground } from '@/components/game/FogBackground';
import { Helmet } from 'react-helmet-async';

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Loup-Garou IA - Jeu de société animé par Intelligence Artificielle</title>
        <meta 
          name="description" 
          content="Jouez au Loup-Garou sans animateur ! IA narrative vocale, distribution automatique des rôles, votes et phases gérés. 4-12 joueurs, gratuit, sans compte." 
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0a0e17" />
        <link rel="manifest" href="/manifest.json" />
      </Helmet>
      
      <main className="relative min-h-screen overflow-hidden">
        <FogBackground />
        <GameController />
      </main>
    </>
  );
};

export default Index;
